import React from "react";
import styles from "./virtualTourPopup.module.scss";
import closeIcon from "../../../assets/images/close-vt.svg";

const VirtualTourPopup = ({ isOpen, onClose, virtualTourUrl }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay}>
     
      <div className={styles.popupContent}>
      <button className={styles.closeButton} onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </button>
        <div className={styles.virtualTourContainer}>
          <iframe
            src={virtualTourUrl}
            title="Virtual Tour"
            className={styles.virtualTourFrame}
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default VirtualTourPopup; 